import createReactComponent from '../createReactComponent';
var LampWallDown = createReactComponent('LampWallDown', [['path', {
  d: 'M11 13h6l3 7H8l3-7Z',
  key: '9n3qlo'
}], ['path', {
  d: 'M14 13V8a2 2 0 0 0-2-2H8',
  key: '1hu4hb'
}], ['path', {
  d: 'M4 9h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4v6Z',
  key: 's053bc'
}]]);
export default LampWallDown;